<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-tab-group>
  <mat-tab label="Roles">
    <ng-template matTabContent>
      <app-admin-system-roles></app-admin-system-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="ScenarioTemplate Roles">
    <ng-template matTabContent>
      <app-admin-scenario-template-roles></app-admin-scenario-template-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="Scenario Roles">
    <ng-template matTabContent>
      <app-admin-scenario-roles></app-admin-scenario-roles>
    </ng-template>
  </mat-tab>
</mat-tab-group>
